import { Form } from "react-bootstrap";

// Lazy load to avoid circular dependency in @rjsf/core
let DefaultFileWidget = null;
function getDefaultFileWidget() {
    if (!DefaultFileWidget) {
        DefaultFileWidget = require("@rjsf/core/lib/components/widgets/FileWidget").default;
    }
    return DefaultFileWidget;
}

export const FileWidget = props => {
    const Widget = getDefaultFileWidget();
    return (
        <Form.Group className="fileWidget">
            <Form.Label className={props.rawErrors ? "text-danger" : ""}>{props.label}</Form.Label>
            <Widget {...props} />
        </Form.Group>
    );
};
